import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { VinculacionEstadoFinanciero } from '../_models/vinculacion-estado-financiero';

@Injectable({
  providedIn: 'root'
})
export class VinculacionEstadoFinancieroService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/vinculacionesEstadoFinanciero/';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as VinculacionEstadoFinanciero[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + 'enabled' ).pipe( map( res => res as VinculacionEstadoFinanciero[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + id ).pipe( map( res => res as VinculacionEstadoFinanciero ) );
  }

  crear( regCrear: VinculacionEstadoFinanciero ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as VinculacionEstadoFinanciero ) );
  }

  actualizar( regActualizar: VinculacionEstadoFinanciero ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as VinculacionEstadoFinanciero ) );
  }
}
